export const accent = 'rgb(48, 161, 78)';
export const accent_sheer = 'rgba(48, 161, 78, .08)';
